import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import { errorMessageNotification } from "../../../../helpers";
import { Modal, Checkbox, Row, Col, notification as Notification, Result, Button, Input } from 'antd';

const { TextArea } = Input;


class TripApprovalDetailOk extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checkedItems: [],
            loadings: {
                submit: false
            },
            isSuccess: false,
            message: ""
        };
    }

    componentWillMount() {
    }


    onChangeCheckBox = (item) => {
        let { checkedItems } = this.state;

        if (checkedItems.some(e => e.value === item.value)) {
            checkedItems = checkedItems.filter(x => x.value !== item.value)
        } else {
            checkedItems.push(item)
        }

        this.setState({ checkedItems })

    }

    fetch = () => {

        let endpoint = { keyOne: "trip", idOne: this.props.id, keyTwo: "vendortripcostresponse" };

        let { loadings, message } = this.state;

        loadings.submit = true;
        this.setState({ loadings });


        this.props
            .dispatch(
                actions.definitions.addData({
                    ...endpoint,
                    data: {
                        id: this.props.id,
                        controlMessage : message
                    },
                })
            )
            .then(() => {
                loadings.submit = false;

                this.setState({
                    loadings, isSuccess: true
                });
                this.props.onSuccess()

            })
            .catch((error) => {
                loadings.submit = false;
                this.setState({ loadings });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

                setTimeout(() => {
                    Notification.destroy();
                }, 3000);
            });
    };

    onChangeTextArea = (e) => {
        this.setState({ message: e.target.value })
    }

    render() {

        const { handleToggle, isModalOpen, warningMessage, confirms, cost } = this.props;
        let { checkedItems, loadings, isSuccess, message } = this.state

        let isTextArea = false;

        if(cost.isDistanceControl || cost.isPointControl){
            isTextArea = true;
        }

        let isApproveButtonDisable = true;

        if(isTextArea){
            if(checkedItems.length === confirms.length && message.length > 0){
                isApproveButtonDisable = false;
            }else{
                isApproveButtonDisable = true;
            }
        }else{
            if(checkedItems.length === confirms.length){
                isApproveButtonDisable = false;
            }else{
                isApproveButtonDisable = true;
            }
        }

      

        return (

            <Modal
                className='approval-ok-modal'
                title="Yolculuk Onayı" centered
                open={isModalOpen}
                onOk={() => !isSuccess ? this.fetch() : handleToggle}
                onCancel={handleToggle}
                maskClosable={false}
                destroyOnClose={true}
                width={760}
                footer={[
                    !isSuccess &&
                    <Button onClick={handleToggle}>
                        İptal
                    </Button>,

                    !isSuccess ?
                        <Button type='primary' onClick={() => this.fetch()}
                            disabled={isApproveButtonDisable}
                            loading={loadings.submit}
                        >
                            Onayla
                        </Button >
                        :
                        <Button type='primary' onClick={handleToggle}
                            disabled={isApproveButtonDisable}
                        >
                            Kapat
                        </Button >
                ]}
            >

                {
                    isSuccess &&
                    <Result
                        status="success"
                        title="Bu talebi onayladınız"
                    />
                }

                {
                    !isSuccess &&
                    <Fragment>

                        <Row>
                            <Col>
                                <div className='warning mb-10'>{warningMessage}</div>
                            </Col>
                        </Row>

                        {
                            cost.isDistanceControl &&
                            <Row>
                                <Col>
                                    <div className='warning mb-10'>{cost.distanceControlMessage}</div>
                                </Col>
                            </Row>
                        }
                        {
                            cost.isPointControl &&
                            <Row>
                                <Col>
                                    <div className='warning mb-10'>{cost.pointControlMessage}</div>
                                </Col>
                            </Row>
                        }


                        <Row>
                            <Col>
                                <div className='prompt'>Bu yolculuğu onaylıyor musun?</div>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                {
                                    confirms.map((item) => {
                                        return (
                                            <div key={item.value}>
                                                <Checkbox key={item.value}
                                                    onChange={(e) => this.onChangeCheckBox(item)}>
                                                    {item.text}
                                                </Checkbox>
                                            </div>
                                        )
                                    })
                                }

                            </Col>
                        </Row>
                     
                        {
                            isTextArea &&
                            <Fragment>
                            <Row>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <TextArea rows={4} placeholder='Mesajınızı giriniz'
                                        onChange={(e) => this.onChangeTextArea(e)}
                                    />
                                </Col>
                            </Row>
                               <Row>
                               <Col>
                                   <div className='info'>Bu alan zorunlu</div>
                               </Col>
                           </Row>
                           </Fragment>
                        }

                    </Fragment>
                }


            </Modal>
        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripApprovalDetailOk);


// WEBPACK FOOTER //
// ./src/components/App/Views/TripApproval/TripApprovalDetailOk.js